import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'

import { setCurrentBien, fetchBien } from '@/features/biens/biensSlice'
import BienContext from '@/features/biens/BienContext'

// Composants par statut
import LocationPasCommencee from './components/LocationPasCommencee'
import LocationEnCours from './components/LocationEnCours'
import LocationTerminee from './components/LocationTerminee'

import { formatDate } from '@/utils/formatters'

const BienShow = ({bien, location, mandat_active, mandat_date_fin}) => {
  const dispatch = useDispatch()
  const currentBien = useSelector((state) => state.biens.current)
  const loading = useSelector((state) => state.biens.loadingStatus.fetchItem)

  useEffect(() => {
    dispatch(setCurrentBien({...bien, location, mandat_active, mandat_date_fin}));
    dispatch(fetchBien(bien.id))
  }, [bien.id])

  const renderLocationContent = () => {
    const locationStatus = currentBien?.location?.status || 
      bien?.location?.status || 
      location?.status

    switch(locationStatus) {
      case 'pas_commencee':
        return <LocationPasCommencee />
      case 'en_cours':
        return <LocationEnCours />
      case 'terminee':
        return <LocationTerminee />
      default:
        return (
          <div>
            <span>Aucune location disponible</span>
          </div>
        )
    }
  }

  return (
    <BienContext.Provider value={{
      bien: currentBien || bien,
      loading
    }}>
      <div className="show-container">
        <div className="content-container space-y-4">
          {(currentBien && currentBien.mandat_active === false) && 
            <div role="alert" className="alert alert-warning text-lg text-white bg-primary-500 border-primary-300 rounded-none">
              <ExclamationCircleIcon className="h-6 w-6"/>
              <div className="flex flex-col space-y-2">
                <span>
                  L'agence HPI ne gère plus votre logement depuis le {formatDate(currentBien.mandat_date_fin)}.
                </span>
                <span>
                  Toutefois, retrouvez ci-dessous tous vos documents et informations concernant la période de gestion.
                </span>
              </div>
            </div> 
          }
          {renderLocationContent()}
        </div>
      </div>
    </BienContext.Provider>
  )
}

export default BienShow
